import { authedAxios } from "../utils/customHttpHeader";

export const paymentLinkService = {
  createPaymentLink: async (payload) => {
    try {
      const response = await authedAxios().post(
        `/payment-gateway/send-payment-link`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error creating payment link:", error);
      if (error.response?.data) {
        throw error.response.data;
      }
      throw {
        status: "error",
        message: error.message || "Failed to create payment link"
      };
    }
  }
};